"use strict";

module.exports = {
  M_30: 30,
  M_36: 36,
  M_42: 42,
  M_60: 60,
  M_66: 66,
  M_78: 78,
  M_84: 84,
  M_120: 120,
  M_138: 138
};